import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=55be2f03&scoped=true&"
import script from "./callback.vue?vue&type=script&lang=js&"
export * from "./callback.vue?vue&type=script&lang=js&"
import style0 from "./callback.vue?vue&type=style&index=0&id=55be2f03&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be2f03",
  null
  
)

export default component.exports